<template>
  <v-container class="galeria-noticia">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form>
        <PageTitle
          icon="mdi-pencil-box-outline"
          main="Painel de notícias"
          sub="Galerias de fotos e videos"
          home='/noticias'
        />
        <div>
          <galeria />
        </div>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Galeria from '../galeria/index.vue'
export default {
  name: 'GaleriaNoticias',
  components: { PageTitle, Galeria },
  data: () => ({
  })
}
</script>

<style scoped>
</style>
